import { render, staticRenderFns } from "./ModalCampaignManualDonationQuestions.vue?vue&type=template&id=35b134da&scoped=true"
import script from "./ModalCampaignManualDonationQuestions.vue?vue&type=script&lang=js"
export * from "./ModalCampaignManualDonationQuestions.vue?vue&type=script&lang=js"
import style0 from "./ModalCampaignManualDonationQuestions.vue?vue&type=style&index=0&id=35b134da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b134da",
  null
  
)

export default component.exports